import { useTranslation } from 'react-i18next';
import { Dialog, TextV2 } from '@insights-ltd/design-library/components';

export type ConfirmType = 'grant' | 'remove';
export type ConfirmAccessDialogProps = {
  open: boolean;
  confirmType: ConfirmType | undefined;
  onClose: () => void;
  handleConfirm: () => void;
  processing: boolean;
  usersName: string;
};

const textKeys: Record<ConfirmType, { [key: string]: string }> = {
  grant: {
    body: 'ui.event-management.access.confirm-grant.body',
    confirmButton: 'ui.event-management.access.confirm-grant.yes-button',
  },
  remove: {
    body: 'ui.event-management.access.confirm-remove.body',
    confirmButton: 'ui.event-management.access.confirm-remove.yes-button',
  },
};

const ConfirmAccessDialog = ({
  open,
  onClose,
  confirmType,
  handleConfirm,
  processing,
  usersName,
}: ConfirmAccessDialogProps) => {
  const { t } = useTranslation();

  if (!confirmType) {
    return null;
  }

  const { body, confirmButton } = textKeys[confirmType];

  return (
    <Dialog
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
      open={open}
      onClose={onClose}
      title={t('ui.event-management.access.confirm.title')}
      content={
        <>
          <TextV2 variant="body1">{t(body, { name: usersName })}</TextV2>
          <TextV2 color="textSecondary" variant="body1">
            {t('ui.event-management.access.confirm.caption')}
          </TextV2>
        </>
      }
      primaryButtonText={t(confirmButton)}
      onSubmit={handleConfirm}
      disablePrimaryButton={processing}
      secondaryButtonText={t('ui.event-management.access.confirm.no-button')}
    />
  );
};

export default ConfirmAccessDialog;
